// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textinputsjob {
    border-radius: 10px;
    display: block;
    background-color: #EDECF8; 
    border: 1px solid #EDECF8; 
    height: 50px; 
    width: 100%;
    
}

.jobbtn {
    margin: 0 auto; 
    width: 100%; 
    height: 48px; 
    margin-bottom: 10px;
}

.textinputsjob2 {
    border-radius: 10px;
    display: block;
    height: 200px; 
    width: 100%;
    
}`, "",{"version":3,"sources":["webpack://./src/components/Getajob.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,WAAW;;AAEf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,WAAW;;AAEf","sourcesContent":[".textinputsjob {\n    border-radius: 10px;\n    display: block;\n    background-color: #EDECF8; \n    border: 1px solid #EDECF8; \n    height: 50px; \n    width: 100%;\n    \n}\n\n.jobbtn {\n    margin: 0 auto; \n    width: 100%; \n    height: 48px; \n    margin-bottom: 10px;\n}\n\n.textinputsjob2 {\n    border-radius: 10px;\n    display: block;\n    height: 200px; \n    width: 100%;\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
